export default __webpack_public_path__ + "static/media/Fiche inscription.a1d7af55.pdf";